export default __webpack_public_path__ + "static/media/greenBG.076eeb2b.png";